import { WidgetRegistry } from "@smallstack/widget-core";
import { CustomFieldsCompoundWidget } from "./lib/widgets/custom-fields-compound-widget";

export function addCompoundWidgets(widgetRegistry: WidgetRegistry): void {
  widgetRegistry.addWidget(CustomFieldsCompoundWidget);
}
